import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reglementation',
  templateUrl: './reglementation.component.html',
  styleUrls: ['./reglementation.component.scss']
})
export class ReglementationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
